// sites.tsx
// Route : /sites — parent layout for all site-scoped pages.

import { createFileRoute, Outlet } from "@tanstack/react-router";

import { AppLayout } from "@/presentation/layouts/AppLayout";

export const Route = createFileRoute("/sites")({
  component: function SitesComponent() {
    return (
      <AppLayout>
        <Outlet />
      </AppLayout>
    );
  },
});
